module.exports = __webpack_public_path__ + "img/event-1@2x.c26cd1e2.png";